import { render, staticRenderFns } from "./SaveButtons.vue?vue&type=template&id=77476818&"
import script from "./SaveButtons.vue?vue&type=script&lang=js&"
export * from "./SaveButtons.vue?vue&type=script&lang=js&"
import style0 from "./SaveButtons.vue?vue&type=style&index=0&id=77476818&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports